<template>
	<v-card flat color="transparent">	
		<NavigationItem class="pl-6"
			name="Live Chat"
				iconcolor="primary"
				description="Auf Soforthilfe zugreifen"
				type="click"
				icon="mdi-chat"
				:tooltip="false"
				@click="startChat"
			>
		
		</NavigationItem>
	</v-card>
</template>

<style lang="less">
	.chat-window{
		position: inherit;
	}
</style>

<script>
// import Vue from "vue"
	import Vuex from "vuex";
	import NavigationItem from "@/components/elements/NavigationItem"
	export default {
		name: "LiveChatButton",
		data: () => {
			return {
			}
		},
		components: {
			NavigationItem
		},
		computed: {
			...Vuex.mapState({
				user: state => state.user,
			}),
		},
		methods: {
			startChat(){
				this.$emit("click");
			}
		}
	}
</script>